export function removeProfileNamePrefix(profileName: string) {
  return profileName.startsWith('profile')
    ? profileName.slice(7)
    : profileName;
}
